var _excluded = ["as", "href", "url", "network", "bgColor", "fgColor", "className", "label", "children", "fallback", "defaultSVG"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
var default_key = 'sharethis';
var social_icon = {
  display: 'inline-block',
  width: '50px',
  height: '50px',
  position: 'relative',
  overflow: 'hidden',
  verticalAlign: 'middle'
};
var social_container = {
  position: 'absolute',
  top: '0',
  left: '0',
  width: '100%',
  height: '100%'
};

var social_svg = _objectSpread(_objectSpread({}, social_container), {}, {
  borderRadius: '50%',
  fillRule: 'evenodd'
});

var social_svg_g = {
  transition: 'fill 170ms ease-in-out',
  fill: 'transparent'
};

var makeUriRegex = function makeUriRegex() {
  var socials = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return new RegExp('(?:[/.]|^)($SOCIALS)([.]|$|/)'.replace('$SOCIALS', socials.join('|').replace(/\./g, '\\.')), 'u');
};

var social_icons = new Map();
var network_names = new Set();
var uri_regex = makeUriRegex();

function getNetworks() {
  return _toConsumableArray(network_names);
} // note: deprecate in v7


function getKeys() {
  return getNetworks();
}

function register(social, icon) {
  social_icons.set(social, icon);
  network_names.add(social);
  uri_regex = makeUriRegex( // sort by longest string first
  _toConsumableArray(network_names).sort(function (pre, post) {
    return post.length - pre.length;
  }));
  return icon;
}

function networkFor(url) {
  var _url$match;

  if (!url) {
    return default_key;
  }

  if (url.startsWith('mailto:')) {
    return 'mailto';
  }

  return ((_url$match = url.match(uri_regex)) === null || _url$match === void 0 ? void 0 : _url$match[1]) || default_key;
}

var SocialIcon = /*#__PURE__*/React.forwardRef(function SocialIcon(props, ref) {
  var _props$as = props.as,
      as = _props$as === void 0 ? 'a' : _props$as,
      href = props.href,
      url = props.url,
      network = props.network,
      bgColor = props.bgColor,
      fgColor = props.fgColor,
      className = props.className,
      label = props.label,
      children = props.children,
      fallback = props.fallback,
      defaultSVG = props.defaultSVG,
      rest = _objectWithoutProperties(props, _excluded);

  var networkKey = network || networkFor(url);
  var ariaLabel = label || props['aria-label'] || networkKey;
  var fallbackIcon = (typeof fallback === 'string' ? social_icons.get(fallback) : fallback || defaultSVG) || social_icons.get(default_key);

  var _ref = networkKey === default_key ? fallbackIcon : social_icons.get(networkKey) || {},
      color = _ref.color,
      path = _ref.path;

  return /*#__PURE__*/React.createElement(as, _objectSpread(_objectSpread({
    href: href || url,
    className: "social-icon".concat(className ? " ".concat(className) : '')
  }, rest), {}, {
    style: _objectSpread(_objectSpread({}, social_icon), rest.style),
    'aria-label': ariaLabel,
    ref: ref
  }), /*#__PURE__*/React.createElement("span", {
    className: "social-container",
    style: social_container
  }, /*#__PURE__*/React.createElement("svg", {
    role: "img",
    "aria-label": "".concat(ariaLabel, " social icon"),
    className: "social-svg",
    viewBox: "0 0 64 64",
    style: social_svg
  }, /*#__PURE__*/React.createElement("g", {
    className: "social-svg-icon",
    style: _objectSpread(_objectSpread({}, social_svg_g), {}, {
      fill: fgColor || 'white'
    })
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H64V64H0Z".concat(path)
  })), /*#__PURE__*/React.createElement("g", {
    className: "social-svg-mask",
    style: _objectSpread(_objectSpread({}, social_svg_g), {}, {
      fill: bgColor || color
    })
  }, /*#__PURE__*/React.createElement("path", {
    d: path
  })))), children);
});
export { SocialIcon, getKeys, getNetworks, networkFor, network_names, register, social_icons, uri_regex };